import { useTranslation } from "react-i18next";
import { LANGUAGE_STORAGE_KEY } from "../../../../i18n/config";

/** Current site language ("en" | "ar") and a setter that persists the choice. */
export function useLanguageSwitch() {
  const { i18n } = useTranslation();

  const setLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  };

  return { language: i18n.language === "ar" ? "ar" : "en", setLanguage };
}
